import type { GuardAppEnvironment } from './types';

export const env: GuardAppEnvironment = {
  production: false,
  buildMode: 'dev',
  apiBaseUrl: 'https://ip4x-za.sudosky.com/v1',
  coreApiUrl: 'https://ip4x-core-api.sudosky.com/v1',
  guardAuthMode: 'auto',
  guardTenantId: '',
  defaultDomain: 'stellenboschmuni.ip4cms-member-za.ip4x.systems',
  portalBaseUrl: 'http://localhost:4304',
  appName: 'Guard NOC',
  version: '1.0.0',
  panicPollIntervalMs: 8000,
  alarmSoundEnabled: true,
};
